module.exports = __webpack_public_path__ + "img/kim.facd3f7c.svg";